/**
 * List of field names whose values are converted between boolean and string "1"/"0".
 *
 * - When submitting data (e.g., to the backend), boolean values (`true` / `false`)
 *   for these fields are transformed into strings: `"1"` for `true` and `"0"` for `false`.
 *
 * - When retrieving data, the strings `"1"` and `"0"` are parsed back into booleans.
 *
 * This allows consistent handling of boolean/string conversion in both directions
 * (serialization and deserialization).
 *
 * Example:
 *  true  → "1"  (on save)
 *  "0"   → false (on load)
 */
export const booleanFields = [
  "relative1Unknown",
  "relative2Unknown",
  "firstNameIncorrectCheck",
  "lastNameIncorrectCheck",
  "dateOfBirthIncorrectCheck",
  "placeOfBirthIncorrectCheck",
  "genderIncorrectCheck",
];
